import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-12",
  "use": "menu-12-usage",
  "viewBox": "0 0 164.4 152.07",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 164.4 152.07\" id=\"menu-12\"><title>资源 115</title><g data-name=\"图层 2\"><path d=\"M154.13 16.44H141.8V6.17a6.17 6.17 0 0 0-12.33 0v10.27h-21.92V6.17a6.17 6.17 0 0 0-12.33 0v10.27H73.31V6.17a6.17 6.17 0 0 0-12.31 0v10.27H39V6.17a6.17 6.17 0 0 0-12.33 0v10.27H10.28A10.28 10.28 0 0 0 0 26.72v102.75a10.28 10.28 0 0 0 10.28 10.28h14.38V148a4.12 4.12 0 0 0 4.11 4.11h24.66a4.12 4.12 0 0 0 4.11-4.11v-8.22h49.32V148a4.12 4.12 0 0 0 4.11 4.11h24.66a4.12 4.12 0 0 0 4.11-4.11v-8.22h14.39a10.28 10.28 0 0 0 10.28-10.28V26.72a10.29 10.29 0 0 0-10.28-10.28zm-45.6 56.66l-28.77 41.1a2.07 2.07 0 0 1-1.69.88 2.21 2.21 0 0 1-.77-.16 2 2 0 0 1-1.25-2.23l4.37-26.38H61.65A2 2 0 0 1 60 83l28.8-37a2.08 2.08 0 0 1 2.52-.58 2 2 0 0 1 1.09 2.34l-5.52 22.11h20a2.07 2.07 0 0 1 1.78 1.13 2 2 0 0 1-.14 2.1z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-12.svg
// module id = qjFN
// module chunks = 6